import { ComponentProps, forwardRef } from "react";

export const AvatarMale = forwardRef<
  SVGSVGElement,
  Pick<ComponentProps<"svg">, "width" | "height">
>(function AvatarMale({ width = "90%", height = "90%" }, ref) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 92 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.48988 117.202C10.0593 116.867 10.6914 116.521 11.367 116.15C13.042 115.232 14.985 114.167 16.9074 112.761C21.8467 109.148 25.391 104.654 24.4503 99.6442C20.1554 95.6824 15.8938 90.2027 15.15 82.0271L14.634 82.0375C13.4421 82.0216 12.2915 81.7517 11.2206 81.1455C8.85089 79.8015 7.54972 77.2317 6.92567 74.2972C6.13125 70.5826 6.39359 66.1745 6.77876 63.3931L6.92567 62.8508C7.75156 60.5564 8.77375 59.3102 10.0731 58.768L10.1107 58.7526C10.0163 56.992 9.98455 55.099 9.95181 53.1466C9.77904 42.8459 9.57856 30.8924 0 28.0058C22.1615 0.320104 45.6502 -8.99351 67.8975 9.8907C89.5911 11.0232 99.2667 41.6329 85.7974 58.768H85.2265C86.5252 59.3102 87.548 60.5564 88.3745 62.8508L88.5208 63.3931C88.906 66.1745 89.1683 70.5826 88.3745 74.2972C87.7492 77.2317 86.4505 79.8015 84.079 81.1455C83.008 81.7517 81.8574 82.0216 80.6655 82.0375L80.1495 82.0271C79.4057 90.2027 75.1336 95.6824 70.8381 99.6442C69.4414 107.092 77.9522 113.398 86.2374 117.368C75.0781 124.116 61.9926 128 48 128C33.8933 128 20.7085 124.053 9.48988 117.202Z"
        fill="#0c0917"
      />
    </svg>
  );
});
